<template>
  <div class="error-content">
    <div v-if="type === 'noOrder'">
      <i class="icon no-order"></i>
      <p>暂无订单记录</p>
    </div>
    <div v-else-if="type === 'noData'">
      <i class="icon no-order"></i>
      <p>暂无数据</p>
    </div>
    <div v-else-if="type === 'noAddress'">
      <i class="icon no-address"></i>
      <p>暂无收货地址</p>
    </div>
    <div v-else-if="type === 'serverError'">
      <i class="icon server-error"></i>
      <p>加载失败，请重试</p>
      <button
        class="btn"
        @click="reload"
      >
        重试
      </button>
    </div>
    <div v-else-if="type === 'netError'">
      <i class="icon server-error"></i>
      <p>网络异常，请重试</p>
      <button
        class="btn"
        @click="back"
      >
        重试
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'error',
    props: {
      type: {
        type:String,
        default: ''
      }
    },
    methods: {
      back () {
        if (window.navigator.onLine) {
          this.$router.back()
        }
      },
      reload () {
        if (this.$route.name === 'servererror') {
          this.back()
        } else {
          window.location.reload()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/common.scss";

  .error-content {
    text-align: center;
    padding-top: 400px;
    .icon {
      display: inline-block;
      &.no-order {
        width: 261px;
        height: 322px;
        background: url('../assets/image/no-record.png') no-repeat;
        background-size: 261px 322px;
      }
      &.server-error {
        width: 326px;
        height: 336px;
        background: url('../assets/image/server-error.png') no-repeat;
        background-size: 326px 336px;
      }
      &.no-address {
        width: 164px;
        height: 225px;
        background: url('../assets/image/map.png') no-repeat;
        background-size: 164px 225px;
      }
    }
    p {
      color: #666;
      font-size: 45px;
      margin-top: 40px;
    }
    .btn {
      width: 32%;
      height: 80px;
      border: 1PX solid $color; /* no */
      border-radius: 24px;
      background-color: #fff;
      font-size: 36px;
      color: $color;
      margin-top: 50px;
      outline: 0;
    }
  }
</style>
